import styled from 'styled-components';
import { CommonDropdown, CommonInput } from 'pg-ui-library';

export const Input = styled(CommonInput)`
  width: 100%;
  padding: inherit 0;
  border: 2px solid #f3f4f8;
  background-color: transparent;
`;

export const Dropdown = styled(CommonDropdown)`
  width: 100%;
  padding: inherit 0;
`;

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: 8px;
  justify-content: space-between;
`;

export const AmountInput = styled(Input)`
  text-align: end;
`;

export const CellSpan = styled.span`
  color: #4948ac;

  &:hover {
    cursor: pointer;

    color: #2dcaff;
  }
`;
